import { Typography } from "ots-components-library";
import IconButton from "@mui/material/IconButton";
import { Box } from "@mui/material";
import { useState } from "react";
import { Timeline } from "./Timeline";
import CloseIconSvg from "../../assets/close-icon.svg?react";
import { hoverEffect } from "../../utils/stylingConsts";

import { useAppDispatch } from "../../hooks";
import { setActiveLocation } from "../../redux/features/locationsSlice";
import { formatLocationAddress } from "../../utils";

import type { Location } from "../../types";

import "./LocationDetailView.scss";

export interface LocationDetailViewProps {
  location: Location;
}

function LocationDetailView({ location }: LocationDetailViewProps) {
  const dispatch = useAppDispatch();
  const [showHeaderShadow, setShowHeaderShadow] = useState(false);

  const onScrollHandler = (event: React.UIEvent<HTMLElement>) => {
    setShowHeaderShadow(!(event.currentTarget.scrollTop === 0));
  };

  const {
    core: { locationName },
    fieldOpsHierarchy: { regionName },
    franchiseOpportunity: {
      fieldOperationsContact,
      franchiseeSelectionConsultant,
    },
    locationNumber,
  } = location;

  const getBoxShadow = () => {
    if (showHeaderShadow) {
      return {
        boxShadow:
          "0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 7px 4px -4px rgb(0 0 0 / 14%), 0px 9px 8px -8px rgb(0 0 0 / 12%)",
      };
    }
    return {};
  };

  return (
    <Box className="detail-view-container" sx={{ boxShadow: 3 }}>
      <div className="detail-view">
        <div className="detail-header" style={getBoxShadow()}>
          <div className="close-button">
            <IconButton
              sx={hoverEffect}
              size="medium"
              aria-label="close"
              color="inherit"
              onClick={() => dispatch(setActiveLocation(undefined))}
            >
              <CloseIconSvg />
            </IconButton>
          </div>
          <Typography
            variant="h2"
            color="primary"
            className="detail-view-location-name"
          >
            {locationName}
          </Typography>
        </div>
        <div className="scrollable" onScroll={onScrollHandler}>
          <div className="info">
            <Typography variant="body1" color="secondary">
              #{locationNumber} - {regionName}
            </Typography>
            <Typography>{formatLocationAddress(location)}</Typography>
            <ul className="location-contacts">
              <li>
                <Typography className="label">Area Director</Typography>
                {fieldOperationsContact ? (
                  <Typography
                    color="secondary"
                    fontWeight="bold"
                    className="contact"
                  >
                    {fieldOperationsContact}
                  </Typography>
                ) : (
                  <Typography
                    color="secondary"
                    fontWeight="bold"
                    className="contact"
                  >
                    N/A
                  </Typography>
                )}
              </li>
              <li>
                <Typography className="label">
                  Franchisee Selection Lead
                </Typography>
                {franchiseeSelectionConsultant ? (
                  <Typography
                    color="secondary"
                    fontWeight="bold"
                    className="contact"
                  >
                    {franchiseeSelectionConsultant}
                  </Typography>
                ) : (
                  <Typography
                    color="secondary"
                    fontWeight="bold"
                    className="contact"
                  >
                    N/A
                  </Typography>
                )}
              </li>
            </ul>
            <Timeline location={location} />
            <Typography variant="caption1" className="referral">
              To apply for an activated Restaurant, please click{" "}
              <a
                href="https://cfafranchise.avature.net/RestaurantOpportunities/UserChecker?"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </Typography>

            <div className="detailed-view-whitespace" />
          </div>
        </div>

        {/* <Tabs>
          <TabsList>
            <TabItem tabId="timeline">Timeline</TabItem>
            <TabItem tabId="calendar">Calendar</TabItem>
          </TabsList>
          <PanelsList>
            <TabPanel tabId="timeline">
              <Timeline location={location} />
            </TabPanel>
            <TabPanel tabId="calendar">calendar placeholder</TabPanel>
          </PanelsList>
        </Tabs> */}
      </div>
    </Box>
  );
}

export default LocationDetailView;
